import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {
  Catalog,
  CatalogCreateRequest,
  CatalogsQueryParams,
  CatalogSummary,
  PagedApiResponse,
} from '../../../models/clare';
import {RegistrationSummary} from '../../../models';
import {ProductManagementErrorInterface} from '../../../error/error-handling/product-management-error';

type CatalogCreateFormValue = Omit<CatalogCreateRequest, 'organization_id'>;

export const CatalogActions = createActionGroup({
  source: 'Catalog',
  events: {
    'Load Catalogs': props<{queryParams?: Partial<CatalogsQueryParams>}>(),
    'Load Catalogs Success': props<{catalogs: PagedApiResponse<CatalogSummary>}>(),
    'Load Catalogs Failure': props<{error: ProductManagementErrorInterface}>(),
    'Create Catalog': props<{catalog: CatalogCreateFormValue}>(),
    'Create Catalog Success': props<{catalog: Catalog}>(),
    'Create Catalog Failure': props<{error: ProductManagementErrorInterface}>(),
    'Reset Create Catalog Status': emptyProps(),
    'Delete Catalog': props<{catalogId: number}>(),
    'Delete Catalog Success': props<{catalogId: number}>(),
    'Delete Catalog Failure': props<{catalogId: number; error: ProductManagementErrorInterface}>(),
    'Reset Delete Catalog Status': emptyProps(),
    'Load Catalog Registrations': props<{catalogId: number; catalogKey: string}>(),
    'Load Catalog Registrations Success': props<{
      catalogId: number;
      registrations: RegistrationSummary[];
    }>(),
    'Load Catalog Registrations Failure': props<{
      catalogId: number;
      error: ProductManagementErrorInterface;
    }>(),
    'Reset Catalog Registrations': emptyProps(),
  },
});
